/**
 * Copyright (c) Qwoach LLC 2020. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Artem Bogush <artem@qwoach.com> on 7/17/20
 *
 */
import FeatureItem from "@shared/Subscription/Features/FeatureItem";
import {FeatureIdEnum} from "@shared/Subscription/Features/FeatureIdEnum";

export default class DriveStorageFeature extends FeatureItem {

	maxStorageSize: number = null


	constructor(maxStorageSize: number = null) {
		super();
		this.featureId = FeatureIdEnum.DRIVE_STORAGE
		this.maxStorageSize = maxStorageSize;
		this.title = "Drive Storage"
		this.description = ""

	}
}
